module.exports = ".event-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n  @media screen and (max-width: 767px) {\n    .event-list {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column; } }\n\n.event-item-container.pull-left {\n  margin-right: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/events/event-list/event-list.styles.scss
// module id = 772
// module chunks = 2